<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="isErr = $event.isErr; errMsg = $event.errMsg"
    />

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import MMMonthlyTaxSubmissionRecord from "../../../components/payroll/mmmonthlytaxsubmissionrec/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": MMMonthlyTaxSubmissionRecord,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('alltax.newtaxsubmissionrec'),
      pageTitleValue: "",
      formData: {
        startdate: null,
        enddate: null,
        taxSubDetail: [],
        taxSelectedPayouts: [],

        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      //send req to insert record
      this.$store.dispatch('post', {url: "/mmtaxsubmissionrecord/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "mmmonthlytaxsubmissionrecordlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "mmmonthlytaxsubmissionrecordlist " });
    },
  },
};
</script>